var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppAdobeFirefly({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#EB1000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1338 20.3173H19.9219V24.5722H29.8379V30.4559H19.9219V39.2255H13.0391V14.4335H31.1338V20.3173Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4932 39.2235H34.0176V19.9081H40.4932V39.2235Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1445 9.50086C39.8287 8.87127 40.9163 9.49856 40.7119 10.4022L40.1924 12.702C40.1242 13.0063 40.2098 13.3219 40.4199 13.5507L42.0225 15.2831C42.6534 15.9657 42.0241 17.0506 41.1182 16.8466L38.8125 16.329C38.5074 16.261 38.1912 16.3459 37.9619 16.5555L36.2246 18.1532C35.5403 18.7827 34.4528 18.1555 34.6572 17.2518L35.1768 14.952C35.2449 14.6477 35.1595 14.3321 34.9492 14.1034L33.3467 12.371C32.7159 11.6885 33.3452 10.6037 34.251 10.8075L36.5566 11.3251C36.8618 11.3931 37.1788 11.3084 37.4082 11.0985L39.1445 9.50086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppAdobeFirefly);
export default __webpack_public_path__ + "static/media/B_app_AdobeFirefly.881cbb7d9da032006a0ae2912e34a209.svg";
export { ForwardRef as ReactComponent };